<div class="root row align-center">
  <div *ngIf="currentTeam">
    <app-current-team-card [currentGame]="currentGame" [currentTeam]="currentTeam"></app-current-team-card>
  </div>
  <div *ngIf="teams" class="teams">
    <app-all-teams-card [currentGame]="currentGame" [teams]="teams"></app-all-teams-card>
  </div>
</div>
